import { CONTACT } from "../../lib/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-background text-foreground pt-20 pb-10 border-t border-border">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-16">
        <div className="md:col-span-1">
          <div className="font-display text-3xl font-light leading-none">Rest Assured</div>
          <div className="label-eyebrow text-muted-foreground mt-1">Group Travel LLC</div>
          <p className="text-muted-foreground font-light mt-6 max-w-xs leading-relaxed">
            Hotel and venue group blocks for corporate teams, families, sports groups, social events,
            and congregations.
          </p>
        </div>

        <div>
          <div className="label-eyebrow text-muted-foreground mb-5">Services</div>
          <ul className="space-y-3 font-light">
            {["Corporate & Business", "Family Reunions", "Sports Teams", "Social Events", "Church Events"].map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-eyebrow text-muted-foreground mb-5">Get in touch</div>
          <ul className="space-y-3 font-light">
            <li>
              <a href={CONTACT.phoneHref} className="hover:text-primary transition-colors">{CONTACT.phone}</a>
            </li>
            <li>
              <a href={CONTACT.emailHref} className="hover:text-primary transition-colors break-all">{CONTACT.email}</a>
            </li>
            <li>
              <a href="#contact" className="text-primary hover:underline">Request services →</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4 label-eyebrow text-muted-foreground">
        <span>© {new Date().getFullYear()} Rest Assured Group Travel LLC</span>
        <span>All rooms, one block.</span>
      </div>
    </div>
  </footer>
);
